<template>
    <div class="home">
        <!-- {{ $i18n.locale }} -->
        <div class="w3-row">
            <div class="w3-col s12">
                <img v-if="$i18n.locale === 'ko'" src="@/static/img/kr/loan_home.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'vi'" src="@/static/img/vn/loan_home.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'my'" src="@/static/img/mm/loan_home.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'ne'" src="@/static/img/np/loan_home.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'uz'" src="@/static/img/uz/loan_home.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'lk'" src="@/static/img/lk/loan_home.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'kh'" src="@/static/img/kh/loan_home.png" class="w3-image">
                <img v-else-if="$i18n.locale === 'ph'" src="@/static/img/ph/loan_home.png" class="w3-image">
                <img v-else src="@/static/img/us/loan_home.png" class="w3-image">
            </div>
        </div>
        <div class="w3-row footer">
            <div class="w3-col s12">
                <router-link class="w3-button w3-kmall w3-block w3-large-24" to="/notice">{{ $t('home.text.ok') }}</router-link>
            </div>
        </div>
    </div>
</template>
<style scoped>

    .home {
        margin-bottom: 50px;
    }

  .header-area{
    background: #3db087!important;
    height: 130px;
    text-align: center;
  }

  .title-area{
    background: #29a67a!important;
    color: #ffffff;
    text-align: center;
  }

  .top-square {
    background: #ffffff;color:#29a67a;min-height:  20px;border-top-left-radius: 10px 10px;border-top-right-radius: 10px 10px;font-weight: bold;
  }

  .bottom-square{
    background: #ffffff;min-height: 20px;border-bottom-left-radius: 10px 10px;border-bottom-right-radius: 10px 10px;
  }

  .w3-kmall {
      color: #fff;
      background-color:#8cd136;
  }

  .w3-large-24 {
      font-size: 20px;
  }
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import LoanTable from '@/components/LoanTable.vue'

export default {
  name: 'home'
}
</script>
